import { render, staticRenderFns } from "./UnitProductImageUpload.vue?vue&type=template&id=4a77179d&scoped=true"
import script from "./UnitProductImageUpload.vue?vue&type=script&lang=js"
export * from "./UnitProductImageUpload.vue?vue&type=script&lang=js"
import style0 from "./UnitProductImageUpload.vue?vue&type=style&index=0&id=4a77179d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77179d",
  null
  
)

export default component.exports